import {
    SUBMIT_SSWP_CONFIG,
    DELETE_SSWP_CONFIG,
    GET_MASTER_SSWP_CONFIGURATIONS
} from "./types";

const INITIAL_STATE = {
    submitting: false,
    requesting: false,
    sswpMasterConfigs: [],
    deleting: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SUBMIT_SSWP_CONFIG.REQUEST: {
            return { ...state, requesting: true, submitting: true };
        }
        case SUBMIT_SSWP_CONFIG.SUCCESS: {
            return { ...state, requesting: false, submitting: false };
        }
        case SUBMIT_SSWP_CONFIG.FAIL: {
            return { ...state, requesting: false, submitting: false };
        }
        case GET_MASTER_SSWP_CONFIGURATIONS.REQUEST: {
            return { ...state, requesting: true, sswpMasterConfigs: false };
        }
        case GET_MASTER_SSWP_CONFIGURATIONS.FAIL: {
            return { ...state, requesting: false, sswpMasterConfigs: false };
        }
        case GET_MASTER_SSWP_CONFIGURATIONS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                sswpMasterConfigs: action.payload
            };
        }
        case DELETE_SSWP_CONFIG.REQUEST: {
            return { ...state, requesting: true, deleting: true };
        }
        case DELETE_SSWP_CONFIG.FAIL: {
            return { ...state, requesting: false, deleting: false };
        }
        case DELETE_SSWP_CONFIG.SUCCESS: {
            return { ...state, requesting: false, deleting: false };
        }
        default: {
            return state;
        }
    }
};
